var React = require('react');

function ClearIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.335004 10.0462C-0.111933 10.4931 -0.111932 11.2178 0.335004 11.6647C0.78194 12.1116 1.50657 12.1116 1.9535 11.6647L5.99984 7.61836L10.0463 11.6648C10.4933 12.1118 11.2179 12.1118 11.6648 11.6648C12.1118 11.2179 12.1118 10.4933 11.6648 10.0463L7.61834 5.99986L11.6645 1.9537C12.1114 1.50676 12.1114 0.782138 11.6645 0.335202C11.2176 -0.111734 10.4929 -0.111734 10.046 0.335202L5.99984 4.38136L1.95384 0.335356C1.5069 -0.11158 0.782272 -0.11158 0.335335 0.335356C-0.111601 0.782292 -0.111601 1.50692 0.335335 1.95385L4.38134 5.99986L0.335004 10.0462Z","fill":"#111111","fillOpacity":"0.48"}));
}

ClearIconInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ClearIconInline;

ClearIconInline.default = ClearIconInline;
